import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

/* global $env */
const { NODE_ENV } = $env;

function isJsonString(str) {
    const s = str.trim();

    return (s.startsWith('{') && s.endsWith('}')) || (s.startsWith('[') && s.endsWith(']'));
}

function consumeData(el) {
    const data = { ...el.dataset };

    Object.keys(data).forEach((key) => {
        const value = data[key];

        if (value === 'true') data[key] = true;
        else if (value === 'false') data[key] = false;
        else if (value === 'null') data[key] = null;
        else if (value === 'undefined') data[key] = undefined;
        else if (/^\d+$/.test(value)) data[key] = parseInt(value, 10);
        else if (/^\d*\.\d+$/.test(value)) data[key] = parseFloat(value);
        else if (isJsonString(value)) {
            try {
                data[key] = JSON.parse(value);
            } catch {
                // intentionally ignore parse errors
            }
        }
    });

    if (NODE_ENV === 'production') {
        setTimeout(() => {
            Array.from(el.attributes).forEach((a) => {
                if (a.name.startsWith('data-')) {
                    el.removeAttribute(a.name);
                }
            });
        }, 1);
    }
    return data;
}

export default function registerComponent(name, Component, store) {
  function renderComponent(el, props) {
    let root;
    
    if (el._reactRoot) {
      root = el._reactRoot;
    } else {
      root = createRoot(el);
      el._reactRoot = root;
    }

    root.render(
      store ? (
        <Provider store={store}>
          <Component {...props} />
        </Provider>
      ) : (
        <Component {...props} />
      )
    );

    return () => {
      root.unmount();
      delete el._reactRoot;
    };
  }

  if (!window.components) window.components = {};
  window.components[name] = renderComponent;

  const elements = document.querySelectorAll(`[data-component="${name}"]`);

  elements.forEach(function renderComponentAttribute(el) {
    const { component, unwrapComponent = false, ...props } = consumeData(el);

    if (unwrapComponent && el.parentElement) {
      renderComponent(el.parentElement, props);
      setTimeout(() => el.remove());
    } else {
      renderComponent(el, props);
    }
  });
}

